<template>
  <div class="grid grid-rows-[auto_1fr] h-full">
    <ThreadsNav show-back :show-center="false">
      <!-- <template #center>
        <h2>{{ t(`collection.my`) }}</h2>
      </template> -->
      <template #right>
        <button
          class="btn btn-primary btn-sm"
          @click="
            router.push({
              name: 'collectionEdit',
            })
          "
        >
          {{ t(`collection.create`) }}
        </button>
      </template>
    </ThreadsNav>
    <div class="h-full overflow-auto">
      <CollectionList
        :mateId="mateStore.currentMate?.id!"
        edit
        :show-create="false"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useMate } from "@/stores/mate";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";

const { t } = useI18n();
const mateStore = useMate();
const router = useRouter();
</script>
